var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "createLayer",
          staticClass: "mod-form",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c("j-title-header", { attrs: { options: _vm.title } }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("j-layer-form", {
                ref: "layerForm",
                attrs: { mode: "create" },
                on: { data: _vm.getData }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue m__r--5",
                        on: { click: _vm.saveCreateLayer }
                      },
                      [_vm._v("\n            Create\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      { staticClass: "btn gray", on: { click: _vm.closePage } },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e11a940a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e11a940a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layer/jLayerCreate.vue
// module id = null
// module chunks = 